const getEvents = (schedule, type) => {
  return Array.from(schedule.availabilities).filter(e => e.type === type).map(e => ({
    start: new Date(e.time.start),
    end: new Date(e.time.end),
    calendarId: '1',
    category: 'time',
    id: e.id,
    title: type,
    bgColor: type === 'client' ? 'var(--client-alt)' : 'var(--expert-alt)',
    raw: {
      group: e.raw.group
    }
  }));
};

export default getEvents;